import styled, { css } from "styled-components";
import { KOGMediaQuery } from "@/main/services/utilsLayout";

export const PermissionGridArea = styled.div`
	display: flex;
	flex-direction: row;
	tbody:hover:active {
		cursor: grab;
	}
`;

export const UserGroupsColumn = styled.div`
	width: 100%;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	${({ theme }) =>
		KOGMediaQuery({
			breakpoint: theme.breakpoints.tablet,
			styles: css`
				max-width: 200px;
			`,
		})}
`;

export const AreaActions = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
`;
